/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ReactNode } from 'react';

type SquareButtonProps = {
  height?: number;
  backgroundColor?: 'white' | 'default';
  hasBorder?: boolean;
  textColor?: 'default' | 'black';
  bold?: boolean;
  onClick?: () => void;
  children: ReactNode;
};

export default function SquareButton({
  height = 40,
  backgroundColor = 'default',
  hasBorder = true,
  textColor = 'default',
  bold = false,
  onClick = () => {},
  children
}: SquareButtonProps) {
  return (
    <div
      css={rootStyles(height, backgroundColor, hasBorder, textColor, bold)}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

const rootStyles = (
  height: number,
  backgroundColor: SquareButtonProps['backgroundColor'],
  hasBorder: boolean,
  textColor: SquareButtonProps['textColor'],
  bold: boolean
) => css`
  width: 100%;
  height: ${height}px;
  background-color: ${backgroundColor === 'white'
    ? 'var(--white-color)'
    : 'var(--default-background-color)'};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.8rem;
  border: 1px solid ${hasBorder ? '#1890FF' : 'none'};
  color: ${textColor === 'default'
    ? '#1890FF'
    : 'var(--text-color)'};
  gap: 0.8rem;
  font-weight: ${bold ? 500 : 400};
`;
